import VideoParticipant from './VideoParticipant/VideoParticipant';

export const getMainParticipant = (participants, memberConnectionId, room, setEnableAudio, memberPhone) => {
    if (participants.length === 0) {
        return <></>;
    }

    const member = participants.find(
        (participant) =>
            participant.identity === memberConnectionId || participant.identity === (memberPhone || '').trim(),
    );

    return member ? (
        <VideoParticipant
            key={member.sid}
            participant={member}
            room={room}
            setEnableAudio={setEnableAudio}
        />
    ) : (
        <></>
    );
};
